import React, { useState } from "react";
import { useFormik } from "formik";
import { useAuth } from "../context/AuthProvider";

import {
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  Box,
  Typography,
  Container,
  FormHelperText,
} from "@mui/material";

import { convertDateToRegulariseDate } from "../utils/utils";

import { markMyDaySchema } from "../utils/validation";

import { axiosInstance } from "../service/axiosInstance";

import serviceEndpoints from "../services/serviceEndpoints";

const MarkMyDayForm = ({ date, setShowSuccess }) => {
  const { userDetail } = useAuth();
  const [filteredActivities, setFilteredActivities] = useState(
    Object.values(userDetail?.meta?.MARK_ACTIVITIES || {})
  );

  const { handleSubmit, handleChange, touched, errors, values, setFieldValue } =
    useFormik({
      initialValues: {
        dayType: "",
        activity: "",
        comments: "",
      },
      onSubmit: (values) => {
        if (errors) {
          console.log("errors", errors);
        }

        handleMarkMyDay(values);
      },
      validationSchema: markMyDaySchema,
    });

  const handleMarkMyDay = async (values) => {
    let payload = {
      date: date,
      isHalfDay: values.dayType === "halfDay" ? true : false,
      activity: values.activity,
      comments: values.comments,
    };

    try {
      await axiosInstance.post(serviceEndpoints.markMyDayEndPoint, {
        ...payload,
      });
      // toast.success(res?.data?.data?.message);
      setShowSuccess(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDayTypeChange = (event) => {
    const selectedDayType = event.target.value;
    setFieldValue("dayType", selectedDayType);

    if (selectedDayType === "halfDay") {
      setFilteredActivities(
        Object.values(userDetail?.meta?.MARK_ACTIVITIES || {}).filter(
          (activity) => !["Public Holiday", "On Leave"].includes(activity)
        )
      );
    } else {
      setFilteredActivities(
        Object.values(userDetail?.meta?.MARK_ACTIVITIES || {})
      );
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        marginTop: 4,
        marginBottom: 2,
      }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
          console.log("Errors:", errors);
        }}
      >
        <Typography variant="h6" className="typography_heading date_message">
          Marking my day for {convertDateToRegulariseDate(date)}
        </Typography>
        <Box
          sx={{
            alignItems: "center",
            borderRadius: "30px",
            padding: 2,
            // border: "1px solid #ddd",
            flexDirection: "row",
            marginBottom: 2,
          }}
          className="container_bg"
        >
          {/* half and full day selection */}
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <RadioGroup
              // defaultValue="car"
              row
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: "25px !important",
                  color: touched.dayType && errors.dayType ? "red" : "inherit",
                },
              }}
              name="dayType"
              value={values.dayType}
              onChange={handleDayTypeChange}
            >
              <FormControlLabel
                value="halfDay"
                control={
                  <Radio
                    sx={{
                      color:
                        touched.dayType && errors.dayType ? "red" : "inherit",
                      "&.Mui-checked": {
                        color:
                          touched.dayType && errors.dayType
                            ? "red"
                            : "primary.main",
                      },
                    }}
                  />
                }
                label="Half day"
              />
              <FormControlLabel
                value="fullDay"
                control={
                  <Radio
                    sx={{
                      color:
                        touched.dayType && errors.dayType
                          ? "red !important"
                          : "inherit",
                      "&.Mui-checked": {
                        color:
                          touched.dayType && errors.dayType
                            ? "red !important"
                            : "primary.main",
                      },
                    }}
                  />
                }
                label="Full day"
              />
            </RadioGroup>
            {touched.dayType && errors.dayType && (
              <Typography
                variant="caption"
                color="error"
                component="div"
                sx={{ textAlign: "left", marginTop: "4px" }}
              >
                {errors.dayType}
              </Typography>
            )}
          </Box>
          {/* Select Activity */}
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Select activity <span className="mandatory_mark"> *</span>
            </Typography>
            <FormControl
              fullWidth
              error={touched.activity && Boolean(errors.activity)}
            >
              <InputLabel id="demo-simple-select-label">
                Select activity
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="activity"
                value={values.activity}
                onChange={(e) => setFieldValue("activity", e.target.value)}
                label="Select Activity"
                error={touched.activity && Boolean(errors.activity)}
                helperText={touched.activity && errors.activity}
              >
                {filteredActivities.map((activity, index) => (
                  <MenuItem key={index} value={activity}>
                    {activity}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {touched.activity && errors.activity}
              </FormHelperText>
            </FormControl>
          </Box>

          {/* Comments */}
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Comments <span className="mandatory_mark"> *</span>
            </Typography>
            <TextField
              fullWidth
              label="Add comments"
              // required={true}
              variant="outlined"
              multiline
              rows={3}
              name="comments"
              inputProps={{ maxLength: 250 }}
              onChange={handleChange}
              value={values.comments}
              error={touched.comments && Boolean(errors.comments)}
              helperText={touched.comments && errors.comments}
            />
          </Box>
        </Box>

        <Button type="submit" variant="contained" fullWidth>
          Submit
        </Button>
      </form>
    </Container>
  );
};

export default MarkMyDayForm;
